import { PositionConfig } from "../CoreApp/PositionConfig";

export function IsPositionChart(chartMetadata) {
  const positionConfig = new PositionConfig(chartMetadata);
  return positionConfig.isPositionChart();
}
